module.exports = __webpack_public_path__ + "static/media/my_dp.94277b26.png";